/** @format */

import { createListenerMiddleware } from '@reduxjs/toolkit';
import { revokeAccount } from './app-slice';
import { get } from 'lodash';
import { updateTabCondition } from 'src/pages/booking/slices/booking-slice';
import { bookingConditionApi } from 'src/api/booking-condition-api';
import { debounce } from 'lodash';

// Create the middleware instance and methods
const listenerMiddleware = createListenerMiddleware();

// // Update device selected after device refresh
listenerMiddleware.startListening({
  actionCreator: revokeAccount,
  effect: async (_action, listenerApi) => {
    const state = listenerApi.getState();
    const revokeAccountState = get(state, 'app.revokeAccount');
    console.log('selectRevokeAccount listener', state);
    if (revokeAccountState === true) {
      setTimeout(() => {
        listenerApi.dispatch(revokeAccount(false));
      }, 200);
    }
  }
});

// Tạo hàm debounced cho API call
const debouncedApiCall = debounce((dispatch, payload) => {
  dispatch(bookingConditionApi.endpoints.updateWithoutEffectBookingCondition.initiate(payload))
    .unwrap()
    .catch((error) => {
      console.log('Results tabConditons  listenerMiddleware updateTabCondition error', error);
    });
}, 2000); // 2000ms = 2 giây

listenerMiddleware.startListening({
  actionCreator: updateTabCondition,
  effect: async (action, listenerApi) => {
    // Gọi hàm debounced thay vì gọi trực tiếp
    debouncedApiCall(listenerApi.dispatch, action.payload);
  }
});

export default listenerMiddleware;
